<mat-card-header class="flex align-items-center">
  <shared-title>{{ this.data ? 'Editar' : 'Crear' }} Acción</shared-title>
  <button
    mat-icon-button
    matTooltip="Limpiar formulario"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
</mat-card-header>

<form [formGroup]="actionForm">
  <mat-dialog-content>
    <shared-input
      class="w-full"
      [labelTitle]="'Nombre'"
      [control]="$any(actionForm.get('name'))" />

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [labelTitle]="'Código'"
        [styleText]="'uppercase'"
        [control]="$any(actionForm.get('code'))" />

      <!-- TODO: confirmar la información del combobox -->
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="type">
          <mat-option value="application"> aplicación </mat-option>
          <mat-option value="web"> web </mat-option>
        </mat-select>
        @if (actionForm.controls['type'].hasError('required')) {
          <mat-error>
            <small>Tipo es <strong>requerido</strong></small>
          </mat-error>
        }
      </mat-form-field>
    </div>

    <shared-input
      [labelTitle]="'Descripción'"
      [control]="$any(actionForm.get('description'))" />
  </mat-dialog-content>

  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'"
      >Cancelar</shared-button
    >

    <shared-button
      [disabled]="!actionForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'"
      (click)="submit()"
      >Guardar</shared-button
    >
  </mat-dialog-actions>
</form>
